const themeMeta = document.querySelector('meta[name="theme-color"]')
const iosMeta = document.querySelector(
  'meta[name="apple-mobile-web-app-status-bar-style"]',
)

// Thèmes des pages
const themes = {
  page1: {
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
    textColor: 'white',
    statusColor: '#6b7fdaff',
    // iosStyle: 'black-translucent',
  },
  page2: {
    background: '#f9fafb',
    textColor: '#000000',
    statusColor: '#ffffff',
    // iosStyle: 'default',
  },
}

export function applyTheme(pageId) {
  const theme = themes[pageId]
  document.body.style.background = theme.background
  document.body.style.color = theme.textColor
  themeMeta.setAttribute('content', theme.statusColor)
  iosMeta.setAttribute('content', theme.iosStyle || 'default')
}
